/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcphosted_Hub_DocsInputs */

const en_mcphosted_hub_docs = /** @type {(inputs: Mcphosted_Hub_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the setup steps`)
};

const id_mcphosted_hub_docs = /** @type {(inputs: Mcphosted_Hub_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca langkah pemasangannya`)
};

/**
* | output |
* | --- |
* | "Read the setup steps" |
*
* @param {Mcphosted_Hub_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mcphosted_hub_docs = /** @type {((inputs?: Mcphosted_Hub_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcphosted_Hub_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mcphosted_hub_docs(inputs)
	return en_mcphosted_hub_docs(inputs)
});